import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Grid, Paper } from '@mui/material';

import { Table } from '../../components/table/table';
import { HeadCell, Row, RowCell } from '../../components/table/types';

import { RouterPaths } from '../../router/paths';
import { useGetTemplatesQuery } from '../../api';
import { permissionsCheck } from '../../utils/permission';

export const NotificationTemplates: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const hasPermissionToViewNotifications = permissionsCheck(['READ_NOTIFICATION_TEMPLATES']);

  // api
  const { data: templates } = useGetTemplatesQuery();

  // table cells and rows
  const headCells: HeadCell[] = [
    {
      id: '1',
      label: t('notification-templates.head-cells.event-name'),
    },
    {
      id: '2',
      label: t('notification-templates.head-cells.enabled-transports'),
    },
  ];

  const rows: Row[] | undefined = templates?.templates.map((template) => {
    const { event, transport } = template;

    const cells: RowCell[] = [
      {
        name: 'event',
        value: event,
      },
      {
        name: 'transport',
        value: transport,
        formatting: () => {
          return transport.length === 0 ? '–' : transport.join(', ');
        },
      },
    ];

    return {
      cells,
      onClick: () =>
        hasPermissionToViewNotifications &&
        navigate(`${RouterPaths.NotificationTemplates}/${event}`),
      hover: hasPermissionToViewNotifications,
      sx: { cursor: 'pointer' },
    };
  });

  return (
    <>
      <Grid size={{ xs: 12 }}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <Table headCells={headCells} rows={rows} />
        </Paper>
      </Grid>
    </>
  );
};
